import { ITrainingUserPositionGroup } from '../../../shared/services/user/user.type';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ICurrentSection,
  ITrainingStage,
  ITrainingSearchResultElement,
} from '../../../shared/services/training/training.type';
import { SectionsListModes } from 'src/app/shared/enums';

export const TRAINING_KEY = 'trainingData';

export interface ITrainingState {
  sectionsList: ITrainingUserPositionGroup[];
  trainingFilesList: ITrainingSearchResultElement[];
  currentMode: SectionsListModes;
  section: ICurrentSection | null;
  stage: ITrainingStage | null;
  allDataFetched: boolean;
  isLoading: boolean;
  error: HttpErrorResponse | null;
}

export enum TrainingActions {
  getSectionsList = 'getSectionsList',
  clearStageData = 'clearStageData',
  clearSectionData = 'clearSectionData',
  clearSectionsData = 'clearSectionsData',
  searchResultsFiles = 'searchResultsFiles',
  getCurrentSectionInfo = 'getCurrentSectionInfo',
  getCurrentStage = 'getCurrentStage',
}
